import * as kc from "@progress/kendo-react-charts";
import { isLandscape } from "../../services/mobileService";

const defaults = {
	colours: {
		label: "rgb(74, 74, 74)",
		gridLine: "rgb(200, 200, 200)",
		background: "rgb(255, 255, 255",
		barChart: {
			bar: "rgb(128, 128, 128)",
		},
		lineChart: {
			line: "rgb(74, 74, 74)",
		},
		radarChart: {
			area: "rgb(128, 128, 128)",
		},
	},
};

function getDefaults(type) {
	return type && defaults[type] ? defaults[type] : defaults;
}

function getScreenBound() {
	let screenBound;

	if (isLandscape()) {
		screenBound = window.screen.availHeight;
	} else {
		screenBound = window.screen.availWidth;
	}

	return screenBound;
}

function getLegendFont() {
	const screenBound = getScreenBound();

	if (screenBound < 374) {
		return "0.6rem sans-serif";
	} else if (screenBound < 640) {
		return "0.75rem sans-serif";
	}
	return "0.875rem/1.75 sans-serif";
}

function getLegendHeight() {
	const screenBound = getScreenBound();

	if (screenBound < 640) {
		return 62;
	}

	return 100;
}

function getCategoryAxes(categoryAxes, valueAxes, def, legendFont) {
	const colours = def.format.colours ?? {};

	const result = categoryAxes.map((e, index) => {
		const categories = e.categories ?? [];
		const type = e.displayType === "date" ? "date" : "category";
		const maxDivisions = type === "date" ? e.maxDivisions || 12 : null;
		const rotation = type === "date" ? e.rotation || -45 : e.rotation || "auto";
		const format = type === "date" ? e.dateFormat || "dd MMM yy" : null;

		const getAxisCrossingValues = (w) => {
			return w.position === "left" || w.position === "top"
				? 0
				: categories.length + 1;
		};

		return (
			<kc.ChartCategoryAxisItem
				key={`x${index + 1}`}
				type={type}
				maxDivisions={maxDivisions}
				categories={categories}
				labels={{
					color: colours.label ?? defaults.colours.label,
					font: legendFont,
					rotation,
					format,
				}}
				axisCrossingValue={valueAxes.map(getAxisCrossingValues)}
				line={{
					color: colours.gridLine ?? defaults.colours.gridLine,
				}}
			/>
		);
	});

	return result;
}

function getValuesAxes(valueAxes, categoryAxes, def, legendFont) {
	const colours = def.format.colours ?? {};

	const result = valueAxes.map((e, index) => {
		const getAxisCrossingValues = (w) => {
			if (w.position === "middle") {
				if (e.max) {
					return e.max / 2;
				}
			}

			return (e.reverseOrder === true) ===
				(w.position === "top" || w.position === "left")
				? 0
				: (e.max ?? 0) + 1;
		};

		return (
			<kc.ChartValueAxisItem
				key={e.name ?? `y${index + 1}`}
				axisCrossingValue={categoryAxes.map(getAxisCrossingValues)}
				min={e.min ?? 0}
				max={e.max}
				reverse={e.reverseOrder === true}
				name={e.name ?? null}
				line={{
					color: colours.gridLine ?? "white",
				}}
				labels={{
					font: legendFont,
					visible: e.showUnitLabels ?? true,
				}}
				title={{
					text: e.label ?? null,
					color: colours.label ?? "white",
					font: legendFont,
				}}
				majorUnit={e.units}
			/>
		);
	});

	return result;
}

export {
	getLegendFont,
	getLegendHeight,
	getCategoryAxes,
	getValuesAxes,
	getDefaults,
};
